import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// common
import { updateReportFromReportListSuccess } from '../../common/actions';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// report-common
import { getReportReducers } from '../../report-common';
// feature compensation-group
import * as A from './actions';
//////////////////////////////////////////////////

const {
  setReports,
  initialState,
  setUsedReport,
  setListLoading,
  setInitialState,
  setReportPending,
  deleteItemSuccess,
  setTableTitleSort,
  getItemListSuccess,
  setTableTitleFilter,
  resetListAndPagination,
  handleUpdateReportFromReportListSuccess,
} = getReportReducers({});

const setDriverGuid = (state, driverGuid) => P.$set('driverGuid', driverGuid, state);
const setVendorGuid = (state, vendorGuid) => P.$set('vendorGuid', vendorGuid, state);
const setBranchConfigs = (state, configs) => P.$set('branchConfigs', configs, state);

const getCompensationGroupByGuidSuccess = (state, data) => {
  const { guid } = data;

  const merged = R.mergeRight(R.path(['itemList', guid], state), data);

  return P.$set(`itemList.${guid}`, merged, state);
};

const toggleDetails = (state, guid) => (
  P.$set(`itemList.${guid}.expanded`, R.not(R.path(['itemList', guid, 'expanded'], state)), state)
);

const removeCompensationGroupCompensationSuccess = (state, data) => {
  const { guid, compensationGroupGuid } = data;

  if (R.isNil(R.path(['itemList', compensationGroupGuid], state))) return state;

  const path = `itemList.${compensationGroupGuid}.compensations`;

  if (R.isNil(R.path(R.split('.', path), state))) return state;

  const compensations = R.pathOr([], R.split('.', path), state);
  const index = R.findIndex(R.propEq(guid, GC.FIELD_GUID), compensations);

  return P.$drop(`${path}.${index}`, state);
};

const createOrUpdateCompensationGroupCompensationSuccess = (state, data) => {
  const { guid, compensationGroupGuid } = data;

  if (R.isNil(R.path(['itemList', compensationGroupGuid], state))) return state;

  const path = `itemList.${compensationGroupGuid}.compensations`;
  const compensations = R.pathOr([], R.split('.', path), state);
  const index = R.findIndex(R.propEq(guid, GC.FIELD_GUID), compensations);

  if (R.isNil(R.path(R.split('.', path), state))) return P.$set(path, [data], state);

  if (R.equals(index, -1)) return P.$add(path, data, state);

  return P.$set(`${path}.${index}`, data, state);
};

export default createReducer({
  [A.setReports]: setReports,
  [A.toggleDetails]: toggleDetails,
  [A.setDriverGuid]: setDriverGuid,
  [A.setVendorGuid]: setVendorGuid,
  [A.setUsedReport]: setUsedReport,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.setBranchConfigs]: setBranchConfigs,
  [A.deleteItemSuccess]: deleteItemSuccess,
  [A.setTableTitleSort]: setTableTitleSort,
  [A.setTableTitleSort]: G.setTableTitleSort,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.setTableTitleFilter]: setTableTitleFilter,
  [A.setTableTitleFilter]: G.setTableTitleFilter,
  [A.resetListAndPagination]: resetListAndPagination,
  [A.getCompensationGroupByGuidSuccess]: getCompensationGroupByGuidSuccess,
  [updateReportFromReportListSuccess]: handleUpdateReportFromReportListSuccess,
  [A.removeCompensationGroupCompensationSuccess]: removeCompensationGroupCompensationSuccess,
  [A.createOrUpdateCompensationGroupCompensationSuccess]: createOrUpdateCompensationGroupCompensationSuccess,
}, initialState);
